export const NAVIGATION_ARROW_SIZE = 48;

export const SCROLL_LISTENER_DEBOUNCE = 100;

export const RESIZE_LISTENER_DEBOUNCE = 100;

// Threshold in pixels to adjust the scrollable state when all items are already visible on XL+ screen
export const SCROLL_THRESHOLD = 30;

export enum SwipeDirection {
  Next = 'Next',
  Prev = 'Prev',
}
